import {
  CheckCircle as CheckCircleIcon,
  InfoOutline,
  RadioButtonUnchecked,
} from "@mui/icons-material";
import { Box, Tooltip, Typography, styled, useTheme } from "@mui/material";
import React from "react";
const StyledCheckboxContainer = styled(Box)(({ theme, selected }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  gap: theme.spacing(1),
  padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
  borderRadius: "2rem",
  backgroundColor: "transparent",
  color: selected ? theme.palette.text.form : theme.palette.text.secondary,
  cursor: "pointer",
  transition: theme.transitions.create(
    ["background-color", "border-color", "color"],
    {
      duration: theme.transitions.duration.short,
    }
  ),
  "&:hover": {
    backgroundColor: selected
      ? theme.palette.action.hover
      : theme.palette.action.hover,
  },
}));

const CheckboxWithTooltip = ({
  selected = false,
  label = "Export Market (Buyer From Around The Globe)",
  tooltipText = "60 Mins Auction | Buy Now",
  onClick,
  ...props
}) => {
  const theme = useTheme();

  return (
    <StyledCheckboxContainer
      selected={selected}
      onClick={onClick}
      aria-checked={selected}
      role="checkbox"
      {...props}
      sx={{
        ...(props?.sx || {}),
        boxSizing: "border-box"
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        {selected ? (
          <CheckCircleIcon sx={{ color: "primary.main" }} />
        ) : (
          <RadioButtonUnchecked
            sx={{
              color: theme.palette.text.disabled,
            }}
          />
        )}

        <Typography color="text.form" fontSize={"1rem"} component="span">
          {label}
        </Typography>
      </Box>
      <Tooltip
        title={tooltipText}
        arrow
        placement="top"
        componentsProps={{
          tooltip: {
            sx: {
              color: theme.palette.text.primary,
              boxShadow: theme.shadows[2],
              border: `1px solid ${theme.palette.divider}`,
            },
          },
          arrow: {
            sx: {
              color: theme.palette.background.paper,
              "&:before": {
                border: `1px solid ${theme.palette.divider}`,
              },
            },
          },
        }}
      >
        <InfoOutline
          fontSize="small"
          sx={{
            color: theme.palette.text.disabled,
            "&:hover": {
              color: theme.palette.text.primary,
            },
          }}
        />
      </Tooltip>
    </StyledCheckboxContainer>
  );
};

export default CheckboxWithTooltip;
